export function initSmoothScroll(): void {
  const triggers = document.querySelectorAll<HTMLAnchorElement>('a[href^="#"]');
  if (!triggers.length) return;

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      e.preventDefault();

      const href = trigger.getAttribute("href");
      if (!href) return;

      const targetId = href.replace("#", "");
      if (!targetId) return;

      const targetElement = document.getElementById(targetId);
      if (!targetElement) return;

      const rect = targetElement.getBoundingClientRect().top;
      const offset = window.pageYOffset;
      const gap = 20;
      const target = rect + offset - gap;

      window.scrollTo({
        top: target,
        behavior: "smooth",
      });
    });
  });
}
